const dropdownTrigger = $('.dropdown-ds');
const dropdownDsTrigger = $('.dropdown-ds-trigger');
const sidebar = $('.sidebar');

/**
 * Trigger para o dropdown
 */
function dropdownToggle(e) {
  e.stopPropagation();
  $('.dropdown-ds-content').each(function () {
    $(this).slideUp(250);
    $(this).parent().find('.dropdown-ds').removeClass('open');
  });
  const dropdown = $(this).closest('.dropdown-ds-container');
  const dropdownContent = dropdown.find('.dropdown-ds-content');
  if (!dropdownContent.is(':visible')) {
    dropdownContent.slideDown(250);
    dropdown.find('.dropdown-ds').toggleClass('open');
  } else {
    dropdown.find('.dropdown-ds').removeClass('open')
    dropdownContent.slideUp(250);
  }

  // Se a sidebar estiver fechada e o dropdown tiver a classe trigger
  // Abre a sidebar para que ele se adeque ao tamanho corretamente
  if (sidebar.hasClass('collapsed') && dropdown.find('.dropdown-ds').hasClass('sidebar-trigger')) {
    triggerCollapseSideBar();
  }

  $('.dropdown').find('.dropdown-menu').each(function(e){
    if(!$(this).is(':hidden')){
      $(this).parent().find('.dropdown-toggle').dropdown('toggle');
    }
  })
}

/**
 * Trigger para o dropdown somente com trigger
 */
function dropdownToggleTrigger(e) {
  e.stopPropagation();
  $('.dropdown-ds-content').each(function () {
    $(this).slideUp(250);
    $(this).parent().find('.dropdown-ds').removeClass('open');
  });
  const dropdown = $(this).closest('.dropdown-ds-container');
  let dropdownContent = dropdown.find('.dropdown-ds-content');

  if (dropdown.hasClass('absolute-content')) {
    const target = dropdown.data('target');
    dropdownContent = $(target).find('.dropdown-ds-content');
    dropdownContent.parent().css('top', $(this).offset().top - $(window).scrollTop() + 44);
    dropdownContent.parent().css('left', $(this).offset().left - $(window).scrollLeft() + 20);
    dropdownContent.css('width', $(this).css('width'));
  }

  if (!dropdownContent.is(':visible')) {
    dropdownContent.slideDown(250);
    dropdown.find('.dropdown-ds-trigger').addClass('open');
  } else {
    dropdown.find('.dropdown-ds-trigger').removeClass('open')
    dropdownContent.slideUp(250);
  }


  // Se a sidebar estiver fechada e o dropdown tiver a classe trigger
  // Abre a sidebar para que ele se adeque ao tamanho corretamente
  if (sidebar.hasClass('collapsed') && dropdown.find('.dropdown-ds-trigger').hasClass('sidebar-trigger')) {
    triggerCollapseSideBar();
  }

  $('.dropdown').find('.dropdown-menu').each(function(e){
    if(!$(this).is(':hidden')){
      $(this).parent().find('.dropdown-toggle').dropdown('toggle');
    }
  })
}

/**
 * Collapsa  a sidebar e caso tenha algum dropdown (da sidebar) ativo fecha ele.
 */
function triggerCollapseSideBar() {
  if (!sidebar.hasClass('collapsed')) {
    sidebar.addClass('collapsed');
    $('.content-container').addClass('collapsed');
  } else {
    sidebar.removeClass('collapsed');
    $('.content-container').removeClass('collapsed');
  }
}

/**
 * Adiciona um novo cookie com o valor cookie
 */
const setCookie = (cookie, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toGMTString();
  }
  document.cookie = cookie + '=' + value + expires + '; path=/';
}


/**
 * Aplicando os listener no elemento dropdown
 */
function appllyListenerDropdown() {
  setCookie('cards_active_tab', '');

  // Listener para triggers com a estrutura padrÃ£o do dropdown
  if (dropdownTrigger) {
    dropdownTrigger.each(function (e) {
      $(this).on('click', dropdownToggle);
    })
    // Listener para fechar os dropdowns quando for clicado fora dele
    $(window).on('click', (e) => {
      e.stopPropagation();
      // Se não for o dropdown
      // Fecha ele e atualiza as classes
      if (!$(this).hasClass('.dropdown-ds')) {
        $('.dropdown-ds-content').each(function () {
          if ($(this).is(':visible')) {
            $(this).parent().find('.dropdown-ds').removeClass('open');
            $(this).animate({
              height: 'toggle',
              opacity: 'toggle'
            }, 250);
          }
        });
      }
    });
  }
  // Listener para triggers sem a estrutura padrÃ£o do dropdown (sÃ³ com trigger)
  if (dropdownDsTrigger) {
    dropdownDsTrigger.each(function (e) {
      $(this).on('click', dropdownToggleTrigger);
    })
    if (!dropdownTrigger) {
      // Listener para fechar os dropdowns quando for clicado fora dele (caso sÃ³ exista o trigger)
      $(window).on('click', (e) => {
        e.stopPropagation();
        // Se não for o dropdown
        // Fecha ele e atualiza as classes
        if (!$(this).hasClass('.dropdown-ds-trigger')) {
          $('.dropdown-ds-content').each(function () {
            if ($(this).is(':visible')) {
              $(this).parent().find('.dropdown-ds').removeClass('open');
              $(this).animate({
                height: 'toggle',
                opacity: 'toggle'
              }, 250);
            }
          });
        }
      });
    }
  }

  // Tratamento para o component alert
  $('#alert-confirm').on('click', () => {
    $('.content-container .content').removeClass('has-alert');
  })

  // Listener para o dropdown da sidebar de cartões
  $('.sidebar-dropdown').on('click', function (e) {
    e.stopPropagation();

    const sidebar = $('.sidebar-backdrop .sidebar');
    const container = $('.content-container');

    if (sidebar.hasClass('collapsed')) {
      sidebar.toggleClass('collapsed');
      container.toggleClass('collapsed');

      if ($(this).hasClass('open')) { return; }
    }

    $(this).closest('.sidebar-item-wrapper').find('.sidebar-sub-items').animate({
      height: 'toggle',
      opacity: 'toggle'
    }, 250);

    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
    } else {
      $(this).addClass('open');
    }

    if (!$('.dropdown').find('.dropdown-menu').is(':hidden')) {
      $('[data-bs-toggle="dropdown"]').dropdown('toggle');
    }
  });

  const sidebarDropdown = $('.sidebar-item.active.has-submenu.sidebar-dropdown');

  sidebarDropdown && sidebarDropdown.trigger('click');

  $('.sidebar-sub-items button').on('click', function () {
    const link = $(this).data('route');
    const target = $(this).data('target');

    setCookie('cards_active_tab', target);
    window.open(link, '_self');
  });
}


exports.init = appllyListenerDropdown;
